// material
// components
import Page from '../components/configs/Page';

import {
  //Stack,
  Container,
  //Typography
} from '@mui/material';

import GerirPlanos from '../components/planos/GerirPlanos'

//import Carousel from 'react-multi-carousel';
//import 'react-multi-carousel/lib/styles.css';

// ----------------------------------------------------------------------


export default function Planos() {
  return (
    <Page title="INPACT | Planos">
      <Container maxWidth="xl">
            {/*
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h3" gutterBottom>
                    Planos de Sessão
                </Typography>
            </Stack>
            */}
            <GerirPlanos/>
        
        </Container>
        
    </Page>

  );
}
